import React, { useMemo } from 'react'

import { Tag, Tooltip } from 'antd'

const EllipsedList = ({ data, maxDisplay = 1 }) => {
  const elements = useMemo(() => data.reduce((acc, d, index) => {
    if (index < maxDisplay) {
      acc.displayed.push(d)
    } else {
      acc.ellipsed.push(d)
    }

    return acc
  }, { displayed: [], ellipsed: [] }), [maxDisplay, data])

  return (
    <div className='ellipsed-list flex-row'>
      {elements.displayed.map((d, index) => (
        <div key={`${d.id}_${index}`}>
          {d.content}
        </div>
      ))}
      {(elements.ellipsed.length > 0) && (
        <Tooltip
          overlayStyle={{ maxWidth: 'none' }} title={
            <ul style={{ padding: '0', margin: '0', listStyleType: 'none' }}>
              {elements.ellipsed.map((d, index) => (
                <li key={`${d.id}_${index}`}>{d.content}</li>
              ))}
            </ul>
          }
        >
          <div className='ml-8'>
            <Tag color='blue'>+{elements.ellipsed.length}</Tag>
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export default EllipsedList
